import React from "react";
import { BottomNavigation, BottomNavigationAction, styled } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import Icons from "icons/sidebar";
import useAuth from "hooks/useAuth";

const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  width: "100%",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
  paddingBottom: 8,
  height: 64,
  "& .MuiBottomNavigationAction-root": {
    minWidth: "auto",
    padding: "6px 8px",
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      "& .MuiBottomNavigationAction-label": {
        fontSize: "0.7rem",
        fontWeight: 600,
      },
    },
    "& .MuiBottomNavigationAction-label": {
      fontSize: "0.7rem",
    },
  },
}));

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleChange = (_: any, newValue: string) => {
    navigate(newValue);
  };

  const activeValue = (() => {
    const p = location.pathname;
    if (p.includes("/dashboard/admin-reports")) return "/dashboard/admin-reports";
    if (p.includes("/dashboard/companies")) return "/dashboard/companies";
    if (p.includes("/dashboard/summary")) return "/dashboard/summary";
    if (p.includes("/dashboard/appointments")) return "/dashboard/appointments";
    if (p.includes("/dashboard/history")) return "/dashboard/history";
    if (p.includes("/dashboard/services")) return "/dashboard/services";
    if (p.includes("/dashboard/users")) return "/dashboard/users";
    return "";
  })();

  return (
    <StyledBottomNavigation value={activeValue} onChange={handleChange} showLabels>
      {/* Admin */}
      {user?.kind === "admin" && (
        <BottomNavigationAction
          label="Relatórios"
          value="/dashboard/admin-reports"
          icon={<Icons.AssessmentOutlinedIcon />}
        />
      )}
      {user?.kind === "admin" && (
        <BottomNavigationAction
          label="Empresas"
          value="/dashboard/companies"
          icon={<Icons.StoreIcon />}
        />
      )}

      {/* Owner */}
      {user?.kind === "owner" && (
        <BottomNavigationAction
          label="Resumo"
          value="/dashboard/summary"
          icon={<Icons.DashboardOutlinedIcon />}
        />
      )}
      {(user?.kind === "owner" || user?.kind === "employee") && (
        <BottomNavigationAction
          label="Agenda"
          value="/dashboard/appointments"
          icon={<Icons.EventAvailableIcon />}
        />
      )}
      {(user?.kind === "owner" || user?.kind === "employee") && (
        <BottomNavigationAction
          label="Histórico"
          value="/dashboard/history"
          icon={<Icons.ListIcon />}
        />
      )}
      {user?.kind === "owner" && (
        <BottomNavigationAction
          label="Serviços"
          value="/dashboard/services"
          icon={<Icons.BusinessCenterIcon />}
        />
      )}
      {user?.kind === "owner" && (
        <BottomNavigationAction
          label="Profissionais"
          value="/dashboard/users"
          icon={<Icons.PeopleAltIcon />}
        />
      )}
    </StyledBottomNavigation>
  );
}
